import { Component, Input } from '@angular/core';
import { AddressesComponent } from '../../addresses/addresses.component';

@Component({
  selector: 'app-address-popup',
  templateUrl: './address-popup.component.html',
  styleUrls: ['./address-popup.component.scss']
})
export class AddressPopupComponent {
  @Input() newOrUpdate: boolean = false;

  constructor(public addressesCompo: AddressesComponent) {}

  public close() {
    this.addressesCompo.address_name = '';
    this.addressesCompo.org_name = '';
    this.addressesCompo.address_first_name = '';
    this.addressesCompo.address_last_name = '';
    this.addressesCompo.update_email = '';
    this.addressesCompo.address_nmbr = '';
    this.addressesCompo.address_line1 = '';
    this.addressesCompo.address_line2 = '';
    this.addressesCompo.country = '';
    this.addressesCompo.state = '';
    this.addressesCompo.city = '';
    this.addressesCompo.postal_code = '';

    this.addressesCompo.showModal = false;
  }
}
